import type {AiPromptBoxFooterLeftActionsProps} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-left-actions/ai-prompt-box-footer-left-actions.types';
import type {ReactElement} from 'react';
import React from 'react';
import {AiPromptBoxSize} from '@Components/ai-prompt-box/ai-prompt-box.types';
import styles from './ai-prompt-box-footer-left-actions.module.scss';

const gapClassMap: Record<AiPromptBoxSize, string> = {
  [AiPromptBoxSize.SMALL]: styles.actionsCompact,
  [AiPromptBoxSize.MEDIUM]: styles.actionsDefault,
  [AiPromptBoxSize.SMALL_EXTENDED]: styles.actionsCompact,
  [AiPromptBoxSize.SINGLE_LINE]: styles.actionsCompact,
};

export function AiPromptBoxFooterLeftActions(props: AiPromptBoxFooterLeftActionsProps): ReactElement | null {
  const getActions = (): ReactElement[] | null => {
    const footerLeftActions = props.options ?? [];

    if (footerLeftActions.length === 0) {
      return null;
    }

    return footerLeftActions.map((renderAction, index) => (
      <React.Fragment key={index}>
        {renderAction({promptBoxId: props.id, footerRef: props.footerRef})}
      </React.Fragment>
    ));
  };

  const getFooter = (): ReactElement => {
    return (
      <div data-prompt-box-id={props.id}>
        <div className={`flexbox flex-align-items-center ${gapClassMap[props.size]}`}>{getActions()}</div>
      </div>
    );
  };

  return getFooter();
}
